import PropTypes from 'prop-types';
import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {selectAuthData} from "../../../redux/selectors/auth.js";
import {useRequestAllChargingPointsByIdQuery} from "../../../redux/api/chargingPoints.js";
import './styles.scss'
import {chargePointsAndConnectorsFilter} from "../../../QueryFilters/queries.js";

function OrganizationChargePointsList({organizationId}) {
    const {t} = useTranslation();
    const {user: {id: userId}} = useSelector(selectAuthData);

    const filter = JSON.stringify(chargePointsAndConnectorsFilter)

    const {data} = useRequestAllChargingPointsByIdQuery({ organizationId:organizationId,filter })
    const chargers = data || data?.res || []
    const chargePointsElements = useMemo(() => {
        return chargers.reduce((accumulator, currentCp, index) => {
          
            if (+currentCp.organizationId === +organizationId) {
                const cpElement = (
                    <div key={`org-cp${index}`} className='charge-point__wrap'>
                        <p>{currentCp.name}</p>
                        <p>{currentCp.id} - {currentCp.status}</p>
                        {currentCp?.chargePointConnectors && (
                            <div>
                                {currentCp?.chargePointConnectors?.map((connector, index) => (
                                    <p key={`cp-connector-${index}`}>{("id " + connector.id + " - " + connector.status)}</p>
                                ))}
                            </div>
                        )}
                    </div>
                );
                accumulator.push(cpElement);
            }
            return accumulator;
        }, []);
    }, [data]);

    return (
        <fieldset className='form__section'>
            <legend className='form__section-label form__section-label--3column'>
                <span>{t('charge_point_name')}</span>
                <span>{t('charge_point_id')}</span>
                <span>{t('charge_point_status')}</span>
            </legend>
            {chargePointsElements}
        </fieldset>
    );
}

export default OrganizationChargePointsList;

OrganizationChargePointsList.propTypes = {
    organizationId: PropTypes.string.isRequired
};
